import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const PlaceRightIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M12 19.3604H13.3594C16.6729 19.3604 19.3591 16.6739 19.3594 13.3604V10.6396C19.3592 7.32607 16.673 4.63965 13.3594 4.63965H12V19.3604Z" fill="currentColor" />;
    t1 = <path d="M9 4C6.23858 4 4 6.23858 4 9V15C4 17.7614 6.23858 20 9 20H15C17.7614 20 20 17.7614 20 15V9C20 6.23858 17.7614 4 15 4H9ZM15 5.5C16.933 5.5 18.5 7.067 18.5 9V15C18.5 16.933 16.933 18.5 15 18.5H9C7.067 18.5 5.5 16.933 5.5 15V9C5.5 7.067 7.067 5.5 9 5.5H15Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export default PlaceRightIcon;